"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeShippingPrice = computeShippingPrice;
function computeShippingPrice(shippingCostWithoutDiscount, shippingDiscount) {
    return (+shippingCostWithoutDiscount - +shippingDiscount).toString();
}
